import { useCookies } from "react-cookie";
import { useEffect, useRef } from "react";
import type { LogoutProps } from "./Navigation.interface.ts";

export function Logout({ logout, account, contextPath }: LogoutProps) {
	const [cookies] = useCookies();
	const xsrfToken = cookies["XSRF-TOKEN"] || "";
	const formRef = useRef<HTMLFormElement>(null);

	useEffect(() => {
		if (logout) {
			if (account) {
				sessionStorage.setItem("force_login", "true");
			}

			formRef.current?.submit();
		}
	}, [logout]);

	return (<>
		{logout && <form action={`${contextPath}/logout`} method="post" ref={formRef}>
			<input type="hidden" name="_csrf" value={xsrfToken} />
			{account && <><input type="hidden" name="login" value="true" />
				<input type="hidden" name="username" value={account} /></>}
		</form>}
	</>);
}